




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'input-field',
  props: ['callback'],
  data() {
    return {
      value: ""
    }
  },
  methods: {
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 45 && keyCode !== 43 && keyCode !== 44 && keyCode !== 46) { // 45 is - // 43 is + // 44 is comma // 46 is dot
        $event.preventDefault();
      }
      //$event.target.value.replace(',', '.')
    },
    onChange($event) {
      //console.log('CHANGE', $event)
      //this.value = $event.target.value
      this.value = $event.target.value.replace(',', '.')
      //$event.target.value = this.value
      if(this.callback) this.callback.call(this, this.value)
    },
    getValue() {
      return this.value//parseFloat(this.value)
    },
    setValue(value) {
      //console.log("SET", value, this.$refs.field)
      this.value = value
      //this.$refs.field.$el.value = value
      //console.log("SET after", this.$refs.field)
    },
    getComponent() {
      return this
    }
  },
  computed: {
    /*computedValue() {
      console.log("MOD", this.value)
      return this.value.replace(',', '.')
    }*/
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        //console.log("WAT", this.model)
        //this.elementsSorted = [];
        //for(var i=0; i<this.elements.length; i++) {
        //  if(this.elementsToExercise.indexOf(this.elements[i].value) != -1) this.elementsSorted.push(this.elements[i])
        //}
      }
    }
  }
})
export default class InputField extends Vue {}

